import { z } from "zod";
import { useForm } from "@/hooks/useForm";
import { file, requiredString } from "@/lib/zod";
import { APP_TAB, AppTab } from "@/components/types";
import {
  FEEDBACK_ACCEPTED_FILE_TYPES,
  FEEDBACK_MAX_FILE_SIZE,
} from "../constants";
import { DefaultValues } from "react-hook-form";
import { useMemo } from "react";

export const issueTypeSchema = z.enum(["question", "issue", "idea"]);

export const locationSchema = z.enum(["card_collection", "patient_accounting"]);

export const severitySchema = z.enum(["low", "medium", "high", "urgent"]);

export const feedbackSchema = z.object({
  issueType: issueTypeSchema,
  location: locationSchema,
  severity: severitySchema.optional(),
  description: requiredString,
  screenShot: file()
    .maxSize(FEEDBACK_MAX_FILE_SIZE)
    .format(FEEDBACK_ACCEPTED_FILE_TYPES),
});

export type IssueTypeId = z.infer<typeof issueTypeSchema>;
export type LocationId = z.infer<typeof locationSchema>;
export type SeverityId = z.infer<typeof severitySchema>;
export type FeedbackFormValues = z.infer<typeof feedbackSchema>;

export const APP_TAB_LOCATION: Record<AppTab, LocationId> = {
  [APP_TAB.CARD_COLLECTION]: "card_collection",
  [APP_TAB.PATIENT_AR]: "patient_accounting",
};

export function useFeedbackForm(activeTab: AppTab) {
  const defaultValues: DefaultValues<FeedbackFormValues> = useMemo(
    () => ({
      issueType: "question",
      location: APP_TAB_LOCATION[activeTab],
    }),
    [activeTab],
  );

  return useForm<FeedbackFormValues>(feedbackSchema, {
    defaultValues,
  });
}
